import React from "react";
import { PropTypes } from "prop-types";

import { selectCurrentData } from "../App/selectors";

import { connect } from "react-redux";
import { COLOR } from "../App/constants";
import { withStyles } from "@material-ui/core/styles";

import { platformHandler } from "../platforms/PlatformHandler";
import { languageManager } from "../utils/languageManager";
import { FwTutorialClass } from "../components/FwTutorialClass";
import { setSelectedPPT, setSharePPT, openConfig } from "../App/actions";

import Paper from "@material-ui/core/Paper";
import List from "@material-ui/core/List";
import CircularProgress from "@material-ui/core/CircularProgress";

import FwSlideListItem from "../components/FwSlideListItem";
import { FwScene } from "./FwScene";
import FwSlideConfigDialog from "../components/FwSlideConfigDialog";
import FwModalLoader from "../components/FwModalLoader";

import SelectPDF from "../components/SelectPDF";
import DialogUpload from "../components/DialogUpload";

const styles = theme => ({
  flipwitContent: {
    //height:'100%',
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexWrap: "nowrap",
    flexDirection: "column",
    width: "100%",
    overflow: "auto",
    flex: 9,
  },
  paperTitle: {
    backgroundColor: COLOR.FLIPWIT_COLOR_2,
    color: "black",
    //height: 48,
    minHeight: 48,
    display: "flex",
    justifyContent: "flex-start",
    //display: 'flex',
    alignItems: "center",
    justifyContent: "center",
    width: "100%"
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    //height: '50%',
    //maxHeight: 320,
    maxWidth: 1300,
    //minHeight: 300,
    height: "50%",
    width: "90%",
    margin: theme.spacing.unit,
    minWidth: 230
    //padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  labelTitlePaper: {
    display: "flex",
    alignItems: "inherit",
    fontSize: "1.3em",
    color: "white",
    margin: theme.spacing.unit * 2 + "px " + theme.spacing.unit * 2 + "px"
  },
  labelDescPaper: {
    alignSelf: "self-start",
    margin: theme.spacing.unit * 3
  },
  listSlides: {
    width: "95%",
    backgroundColor: theme.palette.background.paper,
    position: "relative",
    overflowX: "hidden",
    overflowY: "auto",
    border: "2px solid #CCC",
    marginBottom: 24,
    paddingTop: 0,
    //minHeight: 165,
    height: "100%"
  },
  loaderContainer: {
    flex: 1,
    flexDirection: "column",
    display: "flex",
    justifyContent: "center",
    transform: "translateY(" + -24 + "px)"
  },
  allItemsContainer: {
    overflow: "hidden auto",
    display: "flex",
    flexDirection: "column"
  },
  configContainer: {
    width: "100%",
    flexShrink: 0,
    flexDirection: "column",
    display: "flex"
  },
  configItemBlock: {
    margin: theme.spacing.unit,
    padding: theme.spacing.unit,
    border: "2px solid #CCC",
    flexDirection: "row",
    flexShrink: 0,
    alignItems: "center",
    ["@media (min-width: 400px)"]: {
      display: "flex"
    }
  },
  configItemTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing.unit
  },
  configItemDesc: {
    fontSize: "0.9em"
  },

  baseStyle: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#CCCCCC",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "black",
    outline: "none",
    transition: "border .24s ease-in-out",
    textAlign: 'center',
  },

  divSelectPDF: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '16px 0px',
    cursor: 'pointer',
    minWidth: '230px',
    '& > section': {
      width: '90%',
      maxWidth: '1300px',
    }
  },

  contentVertical: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    alignItems: 'center',
    overflow: 'auto',
  }
});

class SelectPresentation extends FwScene {
  state = {
    selected: -1,
    showDialog: true,
    isLan: false,
    showModalLoader: false,
    cloudExpanded: "",
    localExpanded: "",
    filePDF: "",
    page: 0
  };

  constructor(props) {
    super(props);
    this.tutorial = new FwTutorialClass();
  }

  componentDidMount() {
    console.log(
      "entra a selectpresentation con ",
      this.props.location.state.shouldReportCurrentScreenChange
    );
    platformHandler.removeOldSession(
      this.props.location.state.shouldReportCurrentScreenChange
    );

    platformHandler.reportCurrentExhibitorScreen(
      "SelectPresentation",
      {},
      this.props.location.state.shouldReportCurrentScreenChange
    );
    platformHandler.checkTitleBarScene("SelectPresentation");

    platformHandler.getPptsOpen();
    if (!platformHandler.isLocalSession) {
      platformHandler.getPptsCloud();
    }

    //Acá hay un false && para desactivar el tutorial
    if (
      false &&
      !platformHandler.getUserConfig("tutorial_start_presentation_finished")
    ) {
      console.log("VA A NOTIFICAR STARTED");
      platformHandler.setUserConfig(
        "tutorial_start_presentation_started",
        true
      );
      this.tutorial.setShowTutorial(true);
    }
  }

  onButtonPress(index) {
    this.setState({
      selected: index,
      isLan: index < this.props.currentData.localPPTs.length
    });
  }

  closeDialog() {
    this.setState({ showDialog: false });
  }

  onSelectLanPress() {
    console.log("start with lan");
    platformHandler.startWithInternet(false);
    this.onSelectPress();
  }

  onSelectPress() {
    if (this.state.selected !== -1) {
      let currentData = this.props.currentData;
      let isCloud = this.state.selected >= currentData.localPPTs.length;
      let indexPPT = this.state.selected;
      let namePPT = "";
      let idCloud = "";
      if (isCloud) {
        indexPPT = this.state.selected - currentData.localPPTs.length;
        namePPT = currentData.cloudPPTs[indexPPT].name;
        idCloud = currentData.cloudPPTs[indexPPT].id;
      } else {
        namePPT = currentData.localPPTs[indexPPT];
      }

      platformHandler.presentationSelected(namePPT, isCloud, idCloud);
    }
  }

  renderOption(isCloud, listValue, i) {
    if (isCloud) {
      if (this.props.currentData.localPPTs.indexOf(listValue.name) !== -1) {
        return null;
      }
    }
    //let index = isCloud?this.props.currentData.localPPTs.length+i:i;
    this.iteratorCloud++;
    /*return <OptionPPT 
					key={index} 
					textValue={isCloud?listValue.name:listValue} 
					isPair={this.iteratorCloud%2==0}
					index={index} 
					active={this.state.selected == index}
					onItemPressed={this.onButtonPress.bind(this)}
				/>*/
    return null;
  }

  configReceivedFromServer = data => {
    console.log("llega la config ", data);
    this.setState({ showModalLoader: false });

    if (data.config) {
      if (
        data.config.shareFinish !== undefined &&
        data.config.shareFinish !== null
      ) {
        console.log(">>> La setea en ", data.config.shareFinish);
        this.props.dispatch(setSharePPT(data.config));
      } else {
        this.props.dispatch(setSharePPT(false));
        //this.sceneManager.openScene("MainMenu", {config: data.config} );
      }
    } else {
      //this.sceneManager.openScene("MainMenu", {config: "{}"} );
    }

    this.props.dispatch(openConfig());
  };

  onSlideItemClick(idSelected, action, cloudObject, slideName) {
    console.log(this);

    //Si cloudObject es nulo, entonces no es un item de la nube
    let isCloud = cloudObject !== undefined && cloudObject !== null;
    let idCloud = isCloud ? cloudObject.id : "";
    let namePPT = isCloud ? cloudObject.name : slideName;

    console.log("namePPT " + namePPT);

    switch (action) {
      case "conf":
        this.props.dispatch(setSelectedPPT(namePPT, isCloud));
        platformHandler.checkConfigSlides(
          namePPT,
          this.configReceivedFromServer
        );
        this.setState({ showModalLoader: true });
        break;

      case "play":
        console.log("start", namePPT, isCloud, idCloud);

        if (!isCloud) {
          const result = this.props.cloudPPTs.find(ppt => ppt.name === namePPT);

          if (result) {
            isCloud = true;
            idCloud = result.id;
          } else {
            this.openModal({
              title: languageManager.getLangWord("FIRST_UPLOAD_TITLE"),
              message: languageManager.getLangWord("FIRST_UPLOAD_DESC")
            });
            return;
          }
        }

        //const resultado =

        platformHandler.presentationStarted(namePPT, isCloud, idCloud);
        //platformHandler.openScene("PresentationMode");
        break;

      case "edit":
        if (isCloud) {
          platformHandler.initEditor(namePPT, idCloud);
        } else {
          platformHandler.presentationSelected(namePPT, isCloud, idCloud);
        }
        break;

      case "upload":
        this.props.dispatch(setSelectedPPT(namePPT, isCloud));
        this.setState({ uploadingPPT: true });
        platformHandler.uploadPPT(this.cbUpload);
        break;

      case "delete":
        this.openModal({
          title: languageManager.getLangWord("CONFIRMATION"),
          message: languageManager.getLangWord("CONFIRMATION_DELETE"),
          buttons: [
            {
              label: languageManager.getLangWord("YES"),
              callback: () => this.deleteSlides(namePPT)
            },
            { label: languageManager.getLangWord("NO") }
          ]
        });
        break;

      default:
    }
  }

  deleteSlides = namePPT => {
    platformHandler.deleteSlides(namePPT);
    platformHandler.getPptsCloud();
  };

  cbUpload = (state, isWin) => {
    console.log("state", state, isWin);
    if (state.error) {
      this.setState({ uploadingPPT: false });
      this.openModal({
        title: languageManager.getLangWord("FIRST_UPLOAD_TITLE"),
        message: languageManager.getLangWord("ERROR_SAVING")
      });
      return;
    }

    if (!isWin) {
      var pdfjsLib = require("pdfjs-dist");
      var fs = window.require("fs");

      // require('!!file-loader!pdfjs-dist/build/pdf.worker.min.js').default;
      // pdfjsLib.GlobalWorkerOptions.workerSrc = require("pdfjs-dist/build/pdf.worker");

      // Relative path of the PDF file.
      var pdfURL = state.path;
      console.log("rud " + pdfURL);

      // Read the PDF file into a typed array so PDF.js can load it.
      var rawData = new Uint8Array(fs.readFileSync(pdfURL));

      // Load the PDF file.
      pdfjsLib.getDocument(rawData).then(pdfDocument => {
        this.pdfDocument = pdfDocument;

        console.log("# PDF document loaded.");

        this.setState({
          completed: true,
          page: 1,
          pages: pdfDocument.numPages
        });
        this.renderPage();
      });

      this.setState({ filePDF: state.path });
    }
  };

  processPPTsPCList() {
    var elements = [];

    //Agrega los elementos de PowerPoint abiertos
    this.props.localPPTs.forEach(pptName =>
      elements.push(
        <FwSlideListItem
          openedObj={this.getLocalExpanded}
          key={"Item" + elements.length}
          id={elements.length}
          onSlideItemClick={this.onSlideItemClick.bind(this)}
          slideName={pptName}
        />
      )
    );

    //Si no hay ninguna presentación entonces muestra un mensaje de ayuda
    if (elements.length === 0) {
      elements.push(
        <FwSlideListItem
          key={"OnlyItem"}
          id={elements.length}
          slideName={languageManager.getLangWord("NOPPTSOPEN")}
          helpItem
        />
      );
    }

    return elements;
  }

  getCloudExpanded = (command, value) => {
    if (command === "get") {
      return this.state.cloudExpanded;
    } else {
      if (value === this.state.cloudExpanded) {
        this.setState({ cloudExpanded: "" });
      } else {
        let namePPT = this.props.cloudPPTs[value].name;
        this.setState({ cloudExpanded: value });
        //Se supone que al terminar la animacion de expansion pasa al siguiente paso del tutorial
        //pero a veces esto no esta ocurriendo, entonces por seguridad se coloca que a los 2 segundos
        //pase al siguiente paso del tutorial
        this.tutorial.colocarEstadoTutorial(1, 1800);

        platformHandler.checkConfigSlides(namePPT, data => {
          platformHandler.setConfigSlides(data.config, false);
        });
      }
    }
  };

  getLocalExpanded = (command, value) => {
    if (command === "get") {
      return this.state.localExpanded;
    } else {
      if (value === this.state.localExpanded) {
        this.setState({ localExpanded: "" });
      } else {
        this.setState({ localExpanded: value });
      }
    }
  };

  //Cuando termina la animación de apertura de un panel, recibe el id de la que se expande
  transitionEnd = id => {
    this.tutorial.colocarEstadoTutorial(1);
  };

  processPPTsCloudList() {
    var elements = [];

    //Agrega los elementos de la nube abiertos
    this.props.cloudPPTs.forEach(
      function(pptInfo) {
        //Solo agrega las de la nube que no esten locales
        //TODO2 al fin se listan o no los que estén abiertos?
        //if( this.props.localPPTs.indexOf(pptInfo.name) === -1 )
        //{
        elements.push(
          <FwSlideListItem
            transitionEnd={this.transitionEnd}
            openedObj={this.getCloudExpanded}
            key={"Item" + elements.length}
            cloudObject={pptInfo}
            id={elements.length}
            onSlideItemClick={this.onSlideItemClick.bind(this)}
            slideName={pptInfo.name}
            isCloud
          />
        );
        //}
      }.bind(this)
    );

    if (elements.length === 0) {
      this.tutorial.setSteps([
        {
          element: "#itemNoSlides",
          intro: languageManager.getLangWord("INIT_TUTORIAL_STEP_NOSLIDES")
        }
      ]);

      this.tutorial.colocarEstadoTutorial(0);
    } else {
      this.tutorial.setSteps([
        {
          element: "#item0",
          intro: languageManager.getLangWord("INIT_TUTORIAL_STEP0")
        },
        {
          element: "#play_item0",
          intro: languageManager.getLangWord("INIT_TUTORIAL_STEP1")
        }
      ]);

      this.tutorial.colocarEstadoTutorial(0);
    }

    //Si no hay ninguna presentación entonces muestra un mensaje de ayuda
    if (elements.length === 0) {
      elements.push(
        <FwSlideListItem
          key={"OnlyItem"}
          id={elements.length}
          slideName={languageManager.getLangWord("NOCLOUDPPTS")}
          helpItem
        />
      );
    }

    return elements;
  }

  optionDialogStartPPT = value => {
    if (value) {
      platformHandler.presentationStarted(
        platformHandler.getPPTName(),
        true,
        platformHandler.cloudPresentationID
      );
    } else {
      this.setState({ uploadingPPT: false });
    }
  };

  openPptExplorer = () => {
    window.require("electron").remote.app.openFileDialog();
  };

  onProgressPDF = (showLoader, uploadingPPT) => {
    this.setState({
      uploadingPPT,
      showLoader
    });
  };

  render() {
    const { classes } = this.props;

    //console.log("props ", this.props)
    //const {currentData} = this.props;

    this.iteratorCloud = 0;

    var showLoader = true;

    var elementsPC = [];
    var elementsCloud = [];

    //Si ya se cargaron los slides locales
    if (this.props.localPPTs !== undefined && this.props.localPPTs !== null) {
      //Si no es una sesion local debe mirar si ya llegaron las diapositivas que hay en la nube
      if (
        platformHandler.isLocalSession ||
        (this.props.cloudPPTs !== undefined && this.props.cloudPPTs !== null)
      ) {
        var showLoader = false;
        elementsPC = this.processPPTsPCList();
        elementsCloud = this.processPPTsCloudList();
      }
    }

    var noLocalPPTs =
      this.props.localPPTs == null || this.props.localPPTs.length == 0;

    return (
      <React.Fragment>
        <div className={classes.contentVertical}>
          {this.state.showLoader && <FwModalLoader />}
          {this.tutorial.getComponent()}
          <SelectPDF classes={classes} onProgress={this.onProgressPDF} />
          <FwSlideConfigDialog />
          {this.state.uploadingPPT && <DialogUpload />}
          <div className={classes.flipwitContent}>
            {platformHandler.isElectron && (
              <Paper
                className={classes.paper}
                style={{ height: "40%", minHeight: 200 }}
              >
                <div className={classes.paperTitle}>
                  <div className={classes.labelTitlePaper}>
                    {languageManager.getLangWord("PPTSOPEN_TITLE")}
                  </div>
                </div>
                <div className={classes.labelDescPaper}>
                  {languageManager.getLangWord("DESC_PPTSOPEN")}
                </div>
                {!showLoader && (
                  <List
                    className={classes.listSlides}
                    onClick={() => {
                      if (noLocalPPTs) this.openPptExplorer();
                    }}
                    style={noLocalPPTs ? { cursor: "pointer" } : {}}
                  >
                    {elementsPC}
                  </List>
                )}

                {showLoader && (
                  <div className={classes.loaderContainer}>
                    <CircularProgress size={50} />
                  </div>
                )}

                {this.state.showModalLoader && <FwModalLoader />}
              </Paper>
            )}
            <Paper
              className={classes.paper}
              style={{
                height: platformHandler.isElectron ? "55%" : "100%",
                minHeight: 300
              }}
            >
              {/*<div className={classes.paperTitle}>
                        <div className={classes.labelTitlePaper}>{languageManager.getLangWord('TITLE_CLOUD_DOCS')}</div>
                    </div>*/}
              <div className={classes.labelDescPaper}>
                {languageManager.getLangWord("DESC_CLOUD_DOCS")}
              </div>
              {!showLoader && (
                <List className={classes.listSlides}>{elementsCloud}</List>
              )}

              {showLoader && (
                <div className={classes.loaderContainer}>
                  <CircularProgress size={50} />
                </div>
              )}

              {this.state.showModalLoader && <FwModalLoader />}
            </Paper>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SelectPresentation.propTypes = {
  classes: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object
};

SelectPresentation.contextTypes = {
  store: PropTypes.object
};

const mapStateToProps = state => {
  return {
    localPPTs: selectCurrentData(state).localPPTs,
    cloudPPTs: selectCurrentData(state).cloudPPTs,
    stateLoadingPresentation:
      state.containers.appReducer.stateLoadingPresentation,
    language: state.containers.appReducer.language
  };
};

export default connect(mapStateToProps)(
  withStyles(styles, { withTheme: true })(SelectPresentation)
);



// WEBPACK FOOTER //
// ./src/containers/scenes/SelectPresentation.js